import { RouteObject } from 'react-router-dom';
import {
  AdminsTable,
  DataSetsTable,
  ErrorBoundary,
  GroupRoute,
  OrganizationalUnitsTableV2,
  ResearchersTable,
  StudiesTable,
} from 'src/components';
import { UserGroup } from 'src/types/users';
import { OrganizationDetailsPage } from './organizations-details-page';
import { OrganizationPage } from './organizations-page';

export const organizationsRouter: RouteObject[] = [
  {
    path: 'organizations',
    element: (
      <GroupRoute
        groupsPermitted={[UserGroup.RESEARCHER, UserGroup.ADMIN]}
        component={<OrganizationPage />}
      />
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    path: 'organizations/:organizationId',
    element: (
      <GroupRoute
        groupsPermitted={[UserGroup.RESEARCHER, UserGroup.ADMIN]}
        component={<OrganizationDetailsPage />}
      />
    ),
    errorElement: <ErrorBoundary />,
    children: [
      {
        path: 'organizational-units',
        element: (
          <GroupRoute
            groupsPermitted={[UserGroup.RESEARCHER, UserGroup.ADMIN]}
            component={<OrganizationalUnitsTableV2 />}
          />
        ),
        errorElement: <ErrorBoundary />,
        index: true,
      },
      {
        path: 'researchers',
        element: (
          <GroupRoute
            groupsPermitted={[UserGroup.RESEARCHER, UserGroup.ADMIN]}
            component={<ResearchersTable />}
          />
        ),
        errorElement: <ErrorBoundary />,
      },
      {
        path: 'admins',
        element: (
          <GroupRoute
            groupsPermitted={[UserGroup.RESEARCHER, UserGroup.ADMIN]}
            component={<AdminsTable />}
          />
        ),
        errorElement: <ErrorBoundary />,
      },
      {
        path: 'studies',
        element: (
          <GroupRoute
            groupsPermitted={[UserGroup.RESEARCHER, UserGroup.ADMIN]}
            component={<StudiesTable />}
          />
        ),
        errorElement: <ErrorBoundary />,
      },
      {
        path: 'datasets',
        element: (
          <GroupRoute
            groupsPermitted={[UserGroup.RESEARCHER, UserGroup.ADMIN]}
            component={<DataSetsTable />}
          />
        ),
        errorElement: <ErrorBoundary />,
      },
    ],
  },
];
